import * as api from "../../../api/registerApi";
export default {
  // eslint-disable-next-line no-unused-vars
  registerDoctor({ commit }, userData) {
    return api.register(userData);
  },
};
